import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import { Dialog } from '@progress/kendo-react-dialogs';
import styled from 'styled-components';
import dayjs from 'dayjs';

const VacancyDetailModal = ({ data, open, close, className }) => {
  const [state, setState] = useState({
    companyName: '',
    locationName: '',
    data: '',
    jobPay: '',
    jobTitle: '',
    contract: '',
    img: '',
    seniority: '',
    carrer: [],
    isSingleCarrer: true,
    singleCarrer: '',
  });

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      companyName: data.companyName,
      locationName: data.locationName,
      jobPay: data.jobPay,
      data: data.data,
      jobTitle: data.jobTitle,
      logo: data.logo,
      contract: data.contract,
      seniority: data.seniority,
      img: data.img,
    }));
    if (Array.isArray(data.carrer)) {
      data.carrer.forEach((c) => {
        setState((prevstate) => ({
          ...prevstate,
          isSingleCarrer: false,
          carrer: [...prevstate.carrer, c.value],
        }));
      });
    } else if (!!data.carrer) {
      setState((prevState) => ({
        ...prevState,
        isSingleCarrer: true,
        singleCarrer: 'Indiferente',
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        isSingleCarrer: true,
        singleCarrer: data.carrer,
      }));
    }
  }, [data]);

  const formatDate = (date) => {
    return dayjs(date).format('DD.MM.YY');
  };

  if (open)
    return (
      <Dialog title="Detalles de la vacante" onClose={close}>
        <div className={className}>
          <div className="jobContainer">
            <div
              className="jobImage"
              style={{
                backgroundImage: `url("${
                  !!state.img
                    ? state.img
                    : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fnegocio.png?alt=media&token=0e43774b-31b8-4393-bbe3-a6492da45174'
                }")`,
              }}
            />
            <section className="jobDescriptionRight">
              <h1 className="jobTitle">{state.jobTitle}</h1>
              <header className="companyLogoContainer">
                <div className="jobHeaderContainerLeft">
                  <img
                    className="companyLogo"
                    src={
                      !!state.logo
                        ? state.logo
                        : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fnegocio.png?alt=media&token=0e43774b-31b8-4393-bbe3-a6492da45174'
                    }
                    alt=" | LaPieza.io"
                  />
                  <h3>{state.companyName}</h3>
                </div>
                <div className="jobHeaderContainerRight">
                  <h6>{`Ubicación: ${state.locationName === '' ? 'No especificado' : state.locationName}`}</h6>
                  <h6>{`Contrato: ${state.contract}`}</h6>
                  <h6>{state.isSingleCarrer ? state.singleCarrer : state.carrer.toString()}</h6>
                </div>
                <div className="jobHeaderContainerRight">
                  <div>
                    <h5>Publicado {formatDate(state.postedFrom)}</h5>
                  </div>
                  <h6>{state.seniority}</h6>
                  <h6>Paga: {state.jobPay || 'No especificado'}</h6>
                </div>
              </header>
              <div className="ql-editor">
                <article>
                  <ReactQuill value={state.data} readOnly theme="bubble" />
                </article>
              </div>
            </section>
          </div>
        </div>
      </Dialog>
    );

  return null;
};

export default styled(VacancyDetailModal)`
  position: relative;
  width: 70%;
  margin: 10px auto;
  overflow-y: auto;
  height: 85vh;
  border: 2px solid #000;
  padding: 16px;
  outline: none;
  font-family: futura-pt;
  .ModalHead {
    display: flex;
    padding: 10px 20px;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
  .CloseIcon {
    font-size: 2.5rem !important;
    color: black;
    position: absolute;
    left: calc(100% - 2.5rem);
    top: 1rem;
  }
  .VacancyImage {
    width: 30%;
    margin: 10px auto;
  }
  .jobContainer {
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
  }
  .jobImage {
    width: 100%;
    padding: 0;
    margin: 0;
    height: 300px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    &:after {
      position: absolute;
      background-color: rgb(25, 25, 25);
      content: ' ';
      opacity: 0.4;
      inset: 0px;
    }
  }
  .jobDescriptionRight {
    width: 100%;
    padding: 14px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .jobTitle {
    font-size: 2.8rem;
    text-align: start;
    margin-bottom: 14px;
  }
  .companyLogoContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .companyLogo {
    width: 80px;
    height: 80px;
    object-fit: contain;
    border-radius: 50%;
    background-color: white;
  }
  .jobHeaderContainerLeft {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 14px;
  }
  .jobHeaderContainerRight {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 14px;
  }
  .ql-editor {
    article {
      h1 {
        font-size: 36px;
        font-weight: 400;
      }
      h2 {
        font-size: 32px;
        font-weight: 400;
      }
      h3 {
        font-size: 26px;
        font-weight: 400;
      }
      p {
        font-size: 18px;
        line-height: calc(1ex / 0.25);
        font-family: 'Sofia Pro', sans-serif;
      }
      li {
        font-size: 16px;
        line-height: calc(1ex / 0.25);
        margin-top: 4px;
        font-family: 'Sofia Pro', sans-serif;
      }
      strong {
        font-family: 'Cooper Md BT', serif !important;
        font-size: 20px;
        p {
          font-family: 'Cooper Md BT', serif !important;
        }
      }
    }
  }
`;
